import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
